import "./display-card-title.scss";

interface IDisplayCardTitleProps
{
    /** A címként szereplő szöveg */
    text: string;

    /** Ha ez igaz, akkor warning színnel fog megjelenni a cím */
    isWarning: boolean;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function DisplayCardTitle(props: IDisplayCardTitleProps)
{
    return (<div className={_renderColorClassName(props.isWarning)}>{props.text}</div>);
}

/**
 * Meghatározza a szöveg színét.
 * @param warningMessage Ha van, akkor warning kártya lesz látható.
 * @returns
 */
function _renderColorClassName(isWarning: boolean)
{
    return (isWarning ? "display-card-title warning-display-card-title" : "display-card-title success-display-card-title");
}
